export const getFieldAccess = (fieldPermissions, fieldName, canEdit = true) => {
    // Default: ReadOnly if canEdit is false or permission missing
    if (!canEdit) {
        return {
            disabled: true,
            editable: false,
            required: false,
        };
    }

    const safePermissions = Array.isArray(fieldPermissions) ? fieldPermissions : [];

    // canEdit true ama durum için hiç alan izni tanımlı değilse, tüm alanları düzenlenebilir yap
    if (safePermissions.length === 0) {
        return {
            disabled: false,
            editable: true,
            required: false,
        };
    }

    const target = String(fieldName || '').toLowerCase();
    const permission = safePermissions.find((p) => String(p?.fieldName || '').toLowerCase() === target);

    const editable = permission
        ? (typeof permission.editable === 'boolean'
            ? permission.editable
            : String(permission.access || '').toLowerCase() === 'editable')
        : false; // Missing permission => ReadOnly

    return {
        disabled: !editable,
        editable,
        required: permission ? Boolean(permission.required) : false,
    };
};
